module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Chinmaya Vidyalaya Tripura","short_name":"Chinmaya Vidyalaya Tripura","start_url":"/","background_color":"#F8DED3","theme_color":"#FC9369","display":"standalone","icon":"static/images/favicon.ico","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"46b4c579226e80a75ac2a5f8a91e8873"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
